var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sidebar-account"},[_c('div',{staticClass:"text lead mb-0"},[_c('span',{staticClass:"mr-2"},[_vm._v(_vm._s(_vm.initials))])]),_c('p',{staticClass:"text text-muted mb-0"},[_vm._v(_vm._s(_vm.getRoles()))])])}
var staticRenderFns = []

export { render, staticRenderFns }